<template>
  <div
    :class="[
      'tabela-suspensa-container',
      mensagemSuspensa.tipo == 'nao-vigente'
        ? 'tabela-suspensa-container-vermelho'
        : mensagemSuspensa.tipo == 'alterado'
        ? 'tabela-suspensa-container-amarelo'
        : ''
    ]"
  >
    <div
      :class="[
        'tabela-suspensa-mensagem',
        mensagemSuspensa.tipo == 'nao-vigente'
          ? 'tabela-suspensa-mensagem-vermelho'
          : mensagemSuspensa.tipo == 'alterado'
          ? 'tabela-suspensa-mensagem-amarelo'
          : ''
      ]"
    >
      <div v-html="mensagemSuspensa.titulo"></div>
      <div @click="fechaTabelaSuspensa" class="tabela-suspensa-fechar">
        <font-awesome-icon icon="times" />
      </div>
    </div>
    <TabelaPadrao
      :clickLinha="click"
      semTitulo
      templateColumns="150px 5fr"
      :conteudoPaginado="conteudo"
      :conteudoTotal="conteudo"
      :estruturaTabela="estruturaTabela"
      alertaVermelho="Identificamos que o produto não se encontra mais vigente ou foi alterado, entretanto localizamos uma ou mais NCMs correlacionadas vigentes que podem substituir. <br>Clique aqui para selecionar uma nova NCM."
      caminhoAlertaVermelho="vigente"
      mensagemRepetido="Essa NCM já consta na lista de NCMs selecionadas."
    />
  </div>
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "TabelaSuspensa",
  components: {
    TabelaPadrao
  },
  props: {
    conteudo: Array,
    mensagemSuspensa: Object,
    selecionaNcm: Function,
    fechaTabelaSuspensa: Function,
    setLoading: Function
  },
  data() {
    return {
      estruturaTabela: [
        { nome: "NCM", valor: "ncm", alinhamento: "centro" },
        { nome: "DESCRIÇÃO", valor: "descricao" }
      ]
    };
  },
  async created() {
    await this.checaRepetido();
  },
  watch: {
    getArNcmSelecionados: {
      deep: true,
      async handler() {
        await this.checaRepetido();
      }
    },
    conteudo: {
      deep: true,
      async handler() {
        await this.checaRepetido();
      }
    }
  },
  computed: {
    ...mapGetters("listaNcm", [
      "getContador",
      "getNcms",
      "getMensagemNotificacao",
      "getArNcmSelecionados"
    ]),
    ...mapGetters("login", ["getUser", "getAssinatura"])
  },
  methods: {
    ...mapActions("listaNcm", ["salvarNcm"]),
    async click(produto) {
      this.selecionaNcm(produto, false);
      //   this.setLoading(true);
      //   produto.id_usuario = this.getUser.id_usuario;
      //   let existe = this.getArNcmSelecionados.find(f => f.ncm == produto.ncm && f.ex == produto.ex);
      //   if (existe) {
      //     this.pushAlert("Esta NCM já está na sua lista.", "info");
      //   } else {
      //     await this.salvarNcm(produto);
      //   }
      //   this.setLoading(false);
    },
    async checaRepetido() {
      await this.conteudo.forEach(e => {
        let repetido = !!this.getArNcmSelecionados.find(f => f.ncm == e.ncm && f.ex == e.ex);
        this.$set(e, "repetido", repetido);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tabela-suspensa-container {
  position: relative;
  // padding: 15px 0;
  overflow: hidden;
  border: 1px solid var(--azul3);
  border-radius: 6px;
  background: var(--branco);
}
.tabela-suspensa-container-vermelho {
  border: 1px solid var(--vermelho3);
}
.tabela-suspensa-container-amarelo {
  border: 1px solid var(--amarelo3);
}
.tabela-suspensa-fechar {
  // position: absolute;
  // top: 2px;
  // right: 2px;
  font-size: 14px;
  margin-right: 2px;
  margin-bottom: 2px;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--branco);
}
.tabela-suspensa-mensagem {
  height: 25px;
  display: flex;
  line-height: 25px;
  // justify-content: center;
  align-items: center;
  // padding-bottom: 10px;
  padding-left: 10px;
  background: var(--azul3);
  color: var(--branco);
  justify-content: space-between;
  // margin-bottom: 10px;
}
.tabela-suspensa-mensagem-vermelho {
  background: var(--vermelho3);
}
.tabela-suspensa-mensagem-amarelo {
  background: var(--amarelo3);
}
</style>
